import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const RkSystemInformation = React.lazy(async () => ({
    default: (await import('@oc/rk-system-information/module')).RkSystemInformation
}))

export function RkSystemInformationComponent() {
    return <SuspenseWhileLoading LazyComponent={RkSystemInformation} />
}
